import {Model} from 'backbone';

class Totals extends Model.extend({}) {}

export default Totals;
